import _styled, { default as _styled2 } from "styled-components";
import { type FragmentType, graphql, useFragment } from "~/gql/runtime";
import { Wrap } from "~/features/ui/wrap";
import { FilterBar, type Filter } from "~/features/filter/filter-bar";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
const DEFAULT_REGION = {
  label: "All",
  value: ""
};
const DEFAULT_SERVICE = {
  label: "All",
  value: ""
};
const DEFAULT_INDUSTRY = {
  label: "All",
  value: ""
};
type Category = {
  title: string;
  slug: string;
};
const mapOptions = (categories: Category[]) => categories.map(category => ({
  label: category.title,
  value: category.slug
}));
const fragment = graphql(`
  fragment PartnersFilters on Query {
    regions: categories(group: "regionCategory") {
      title
      slug
    }
    services: categories(group: "serviceCategory") {
      title
      slug
    }
    industries: categories(group: "industryCategory") {
      title
      slug
    }
  }
`);
type Props = FragmentType<typeof fragment> & {
  onChange: (type: string, val: string) => void;
  mode: Mode;
  theme: Theme;
  value: {
    region: string;
    service: string;
    industry: string;
  };
};
export function PartnersFilters(props: Props) {
  const {
    onChange,
    value,
    mode,
    theme,
    ...rest
  } = props;
  const {
    regions = [],
    services = [],
    industries = []
  } = useFragment(fragment, rest);
  const themeStyle = getThemeStyle({
    mode,
    theme
  });
  const filters: Filter[] = [{
    title: "Region",
    options: [DEFAULT_REGION, ...mapOptions(regions as Category[])],
    type: "select",
    value: value.region,
    style: {
      "width": "100%",
      "@media (min-width: 1024px)": {
        "width": "calc(33% - 8px)"
      }
    }
  }, {
    title: "Service",
    options: [DEFAULT_SERVICE, ...mapOptions(services as Category[])],
    type: "select",
    value: value.service,
    style: {
      "width": "100%",
      "@media (min-width: 1024px)": {
        "width": "calc(33% - 8px)"
      }
    }
  }, {
    title: "Industry",
    options: [DEFAULT_INDUSTRY, ...mapOptions(industries as Category[])],
    type: "select",
    value: value.industry,
    style: {
      "width": "100%",
      "@media (min-width: 1024px)": {
        "width": "calc(33% - 8px)"
      }
    }
  }];
  return <Wrap mode={mode}>
      <_StyledDiv>
        <_StyledDiv2 $_css={[{
        "position": "relative",
        "zIndex": "10",
        "paddingLeft": "1.6rem",
        "paddingRight": "1.6rem",
        "paddingTop": "2.4rem",
        "paddingBottom": "2.4rem",
        "@media (min-width: 1024px)": {
          "borderLeftWidth": "1px",
          "borderRightWidth": "1px",
          "paddingLeft": "4rem",
          "paddingRight": "4rem"
        }
      }, themeStyle.border, themeStyle.background]}>
          <FilterBar filters={filters} onChange={onChange} />
        </_StyledDiv2>
      </_StyledDiv>
    </Wrap>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-1re2cme-0"
})({
  "@media (min-width: 1024px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
});
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "partners-filters___StyledDiv2",
  componentId: "sc-wc7l07-0"
})(["", ""], p => p.$_css);